/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateLeadDecisionRequestBidirectionalActionDetails } from './UpdateLeadDecisionRequestBidirectionalActionDetails';
import {
    UpdateLeadDecisionRequestBidirectionalActionDetailsFromJSON,
    UpdateLeadDecisionRequestBidirectionalActionDetailsFromJSONTyped,
    UpdateLeadDecisionRequestBidirectionalActionDetailsToJSON,
    UpdateLeadDecisionRequestBidirectionalActionDetailsToJSONTyped,
} from './UpdateLeadDecisionRequestBidirectionalActionDetails';

/**
 * 
 * @export
 * @interface UpdateLeadDecisionRequest
 */
export interface UpdateLeadDecisionRequest {
    /**
     * 
     */
    status_id: string;
    /**
     * 
     */
    bidirectional_action_details?: UpdateLeadDecisionRequestBidirectionalActionDetails;
}

/**
 * Check if a given object implements the UpdateLeadDecisionRequest interface.
 */
export function instanceOfUpdateLeadDecisionRequest(value: object): value is UpdateLeadDecisionRequest {
    if (!('status_id' in value) || value['status_id'] === undefined) return false;
    return true;
}

export function UpdateLeadDecisionRequestFromJSON(json: any): UpdateLeadDecisionRequest {
    return UpdateLeadDecisionRequestFromJSONTyped(json, false);
}

export function UpdateLeadDecisionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeadDecisionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status_id': json['status_id'],
        'bidirectional_action_details': json['bidirectional_action_details'] == null ? undefined : UpdateLeadDecisionRequestBidirectionalActionDetailsFromJSON(json['bidirectional_action_details']),
    };
}

export function UpdateLeadDecisionRequestToJSON(json: any): UpdateLeadDecisionRequest {
    return UpdateLeadDecisionRequestToJSONTyped(json, false);
}

export function UpdateLeadDecisionRequestToJSONTyped(value?: UpdateLeadDecisionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status_id': value['status_id'],
        'bidirectional_action_details': UpdateLeadDecisionRequestBidirectionalActionDetailsToJSON(value['bidirectional_action_details']),
    };
}

